export default __webpack_public_path__ + "assets/wulianwangka.33165c46.svg";